import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const loc = useLocation();
  const nav = useNavigate();
  const params = new URLSearchParams(loc.search);
  const next = params.get("next") || "/results";
  return (
    <>
      <Nav />
      <main className="container-hs py-16 max-w-lg text-center">
        <div data-testid="pay-cancel" className="card-hs p-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-soft text-brand-muted mb-4"><XCircle size={26} /></div>
          <h1 className="font-display text-2xl text-brand-ink">Checkout canceled</h1>
          <p className="text-brand-muted mt-2 text-sm">No worries — your worksheet is still saved on this device. You can continue with Free or unlock 90 days anytime.</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center mt-6">
            <button data-testid="cancel-continue-free" onClick={() => nav(next)} className="btn-secondary">Continue with Free</button>
            <button data-testid="cancel-try-again" onClick={() => nav(`/upgrade?next=${encodeURIComponent(next)}`)} className="btn-primary">Try upgrading again</button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
